import React from 'react';
import { Helmet } from 'react-helmet';
import IndexPage from '../index/index';
const AboutUs = ({ location }) => {
  return (
    <>
      <Helmet>
        <title>Jeetar</title>
      </Helmet>
      <IndexPage location={location} />
    </>
  );
};

export default AboutUs;
